export default ({ app, store }) => {
  const isCookiesAccepted = app.$cookies.get('cookie_accepted') === true
  if (!isCookiesAccepted) {
    return
  }

  store.commit('SET_COOKIE_ACCEPTED')
}
